/**
 * @generated SignedSource<<51774defd383cfbd4d4fa005398e207b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum CommentType {
  FOOTER = "FOOTER",
  INLINE = "INLINE",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author =

    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_User;
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    isDangling: boolean;
    resolvedTime: number | null;
    resolvedFriendlyDate: string | null;
    resolvedUser: string | null;
    resolved: boolean;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by =

    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_Anonymous
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_KnownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_UnknownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_User;
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji =
  {
    __typename?: "ReactionsSummaryForEmoji";
    id: string;
    emojiId: string;
    count: number;
    reacted: boolean;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_reactionsSummary_ReactionsSummaryResponse =
  {
    __typename?: "ReactionsSummaryResponse";
    ari: string;
    containerAri: string;
    reactionsCount: number;
    reactionsSummaryForEmoji: Array<ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji | null>;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author =

    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User;
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    isDangling: boolean;
    resolvedTime: number | null;
    resolvedFriendlyDate: string | null;
    resolvedUser: string | null;
    resolved: boolean;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location =

    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment;
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by =

    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_Anonymous
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_KnownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_UnknownUser
    | ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_User;
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji =
  {
    __typename?: "ReactionsSummaryForEmoji";
    id: string;
    emojiId: string;
    count: number;
    reacted: boolean;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse =
  {
    __typename?: "ReactionsSummaryResponse";
    ari: string;
    containerAri: string;
    reactionsCount: number;
    reactionsSummaryForEmoji: Array<ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji | null>;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment =
  {
    __typename?: "Comment";
    id: string;
    contentStatus: string;
    createdAtNonLocalized: string;
    parentId: string | null;
    author: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author;
    body: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_body_DocumentBody;
    createdAt: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_createdAt_ConfluenceDate;
    links: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_links_Map_LinkType_String;
    location: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location;
    permissions: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_permissions_CommentPermissions;
    version: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version;
    reactionsSummary: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse | null;
  };
export type ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment = {
  __typename?: "Comment";
  id: string;
  contentStatus: string;
  createdAtNonLocalized: string;
  parentId: string | null;
  author: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author;
  body: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_body_DocumentBody;
  createdAt: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate;
  links: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_links_Map_LinkType_String;
  location: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location;
  permissions: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_permissions_CommentPermissions;
  version: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version;
  reactionsSummary: ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_reactionsSummary_ReactionsSummaryResponse | null;
  replies: Array<ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment | null>;
};
export type ActiveCommentsQuery_comments_PaginatedCommentList = {
  __typename?: "PaginatedCommentList";
  totalCount: number | null;
  nodes: Array<ActiveCommentsQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
};
export type ActiveCommentsQuery_Query = {
  __typename?: "Query";
  comments: ActiveCommentsQuery_comments_PaginatedCommentList | null;
};
export type ActiveCommentsQueryVariables = Exact<{
  pageId: Scalars["ID"]["input"];
  contentStatus?: InputMaybe<
    Array<InputMaybe<GraphQLContentStatus>> | InputMaybe<GraphQLContentStatus>
  >;
  type?: InputMaybe<Array<InputMaybe<CommentType>> | InputMaybe<CommentType>>;
  first?: InputMaybe<Scalars["Long"]["input"]>;
}>;
export type ActiveCommentsQuery = ActiveCommentsQuery_Query;
